// The winding-direction options of the paper forms (AVT 5.11, Slitting 5.11), drawn as the
// Master Job Card draws them: LO-1 .. LO-4, the sun mark, LI-1 .. LI-4 (public/rolls).
export const WINDING = ["LO-1", "LO-2", "LO-3", "LO-4", "LI-1", "LI-2", "LI-3", "LI-4"];

/** `ticks` is {"LO-2": true, ...}; `onChange(next)` gets the whole object. `prefix` names the test ids. */
export default function WindingStrip({ ticks, onChange, readOnly, prefix }) {
  return (
    <div className="grid grid-cols-9 items-end gap-1 pt-1.5" data-testid={`${prefix}-strip`}>
      {[...WINDING.slice(0, 4), "SUN", ...WINDING.slice(4)].map((o) => o === "SUN" ? (
        <div key="sun" className="flex flex-col items-center justify-end pb-5" aria-hidden="true">
          <img src="/rolls/sun.png" alt="" className="h-12 object-contain" />
        </div>
      ) : (
        <label key={o} className="flex flex-col items-center gap-0.5 text-[10px]">
          {/* Fixed box (not just height) — Tailwind's img{max-width:100%} preflight would otherwise
              cap the wider icons (LI-4, LO-1) to their grid column before height, so object-contain
              letterboxed them smaller than the narrower ones. A fixed w+h box is the same for all 8. */}
          <div className="w-[88px] h-[72px] flex items-center justify-center">
            {/* -v2 filename forces browsers/proxies that cached the old (differently-sized) art under
                the plain name to fetch fresh instead of silently reusing a stale copy. */}
            <img src={`/rolls/${o.toLowerCase()}-v2.png`} alt={`Roll orientation ${o}`} className="max-w-full max-h-full w-auto h-auto object-contain" data-testid={`${prefix}-roll-${o.toLowerCase()}`} />
          </div>
          <span className="font-semibold font-mono-num">{o}</span>
          <input type="checkbox" className="accent-[#FF5A00] h-3.5 w-3.5" checked={!!ticks[o]} disabled={readOnly}
            onChange={(e) => onChange({ ...ticks, [o]: e.target.checked })} data-testid={`${prefix}-wind-${o}`} />
        </label>
      ))} 
    </div>
  );
}
